import {AppState} from "../app";
import {GrabPointer} from "./updateInput";

enum CursorState {
    Default = "default",
    Grab = "grab",
    Grabbing = "grabbing"
}

export function updatePointer({entities, time, soundEvents, interactiveCanvas}: AppState) {

    let cursorState = CursorState.Default
    for(const pointer of interactiveCanvas.input.pointers)
    {
        const p = pointer as GrabPointer
        if(p.grabbedObject) {
            cursorState = CursorState.Grabbing
            break
        }
        if(p.overlapObjects.length > 0){
            cursorState = CursorState.Grab
            break
        }
    }

    document.body.style.cursor = cursorState
}